import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	yourTeamsTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.your-teams-title-non-final',
		defaultMessage: 'Your teams from Opsgenie',
		description: 'Transition home, find what you are looking for step, your teams title',
	},
	yourTeamsDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.your-teams-description-non-final',
		defaultMessage: 'Where to find it: Jira navigation > Teams > Go to operations',
		description: 'Transition home, find what you are looking for step, your teams description',
	},
	schedulesTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.schedules-title-non-final',
		defaultMessage: 'On-call schedules',
		description: 'Transition home, find what you are looking for step, on-call schedules title',
	},
	schedulesDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.schedules-description-non-final',
		defaultMessage: 'Where to find it: Your work > On-call',
		description:
			'Transition home, find what you are looking for step, on-call schedules description',
	},
	alertsTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.alerts-title-non-final',
		defaultMessage: 'Alerts',
		description: 'Transition home, find what you are looking for step, alerts title',
	},
	alertsDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.alerts-description-non-final',
		defaultMessage: 'Where to find it: Your work > Alerts',
		description: 'Transition home, find what you are looking for step, alerts description',
	},

	notificationSettingsTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.notification-settings-title-non-final',
		defaultMessage: 'Personal notification settings',
		description: 'Transition home, find what you are looking for step, notification settings title',
	},
	notificationSettingsDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.notification-settings-description-non-final',
		defaultMessage: 'Where to find it: Your profile and settings > Personal settings > Alerts',
		description:
			'Transition home, find what you are looking for step, notification settings description',
	},
	reportsTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.reports-title-non-final',
		defaultMessage: 'Reports',
		description: 'Transition home, find what you are looking for step, reports title',
	},
	reportsDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.reports-description-non-final',
		defaultMessage: 'Where to find it: Settings > Products > Reports',
		description: 'Transition home, find what you are looking for step, reports description',
	},
	reportsTeamAdminDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.reports-team-admin-description-non-final',
		defaultMessage: 'Where to find it: Teams > Go to operations > Reports',
		description: 'Transition home, find what you are looking for step, reports description',
	},
	auditTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.audit-title-non-final',
		defaultMessage: 'Audit logs',
		description: 'Transition home, find what you are looking for step, audit logs title',
	},
	auditDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.audit-description-non-final',
		defaultMessage: 'Where to find it: Settings > Products > Audit logs',
		description: 'Transition home, find what you are looking for step, audit logs description',
	},

	rbnTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.rbn-title-non-final',
		defaultMessage: 'Role-based notifications',
		description:
			'Transition home, find what you are looking for step, role based notifications title',
	},
	rbnDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.rbn-description-non-final',
		defaultMessage: 'Where to find it: Settings > Products > Role-based notifications',
		description:
			'Transition home, find what you are looking for step, role based notifications description',
	},
	customRolesTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.custom-roles-title-non-final',
		defaultMessage: 'Custom roles',
		description: 'Transition home, find what you are looking for step, custom roles title',
	},
	customTeamRolesTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.custom-team-roles-title-non-final',
		defaultMessage: 'Custom team roles',
		description: 'Transition home, find what you are looking for step, custom roles title',
	},
	customRolesDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.custom-roles-description-non-final',
		defaultMessage: 'Where to find it: Settings > Products > Custom roles',
		description: 'Transition home, find what you are looking for step, custom roles description',
	},
	customRolesTeamAdminDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.custom-roles-team-admin-description-non-final',
		defaultMessage: 'Where to find it: Teams > Go to operations > Member roles',
		description: 'Transition home, find what you are looking for step, custom roles description',
	},
	automationTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.automation-title-non-final',
		defaultMessage: 'Automation',
		description: 'Transition home, find what you are looking for step, automation title',
	},
	automationDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.automation-description-non-final',
		defaultMessage: 'Where to find it: Settings > System > Automation',
		description: 'Transition home, find what you are looking for step, automation description',
	},
	automationTeamAdminDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.automation-team-admin-description-non-final',
		defaultMessage: 'Where to find it: Teams > Go to operations > Automation',
		description: 'Transition home, find what you are looking for step, automation description',
	},
	syncTitleNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.sync-title-non-final',
		defaultMessage: 'Sync',
		description: 'Transition home, find what you are looking for step, sync title',
	},
	syncDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.sync-description-non-final',
		defaultMessage: 'Where to find it: Settings > System > Sync',
		description: 'Transition home, find what you are looking for step, sync description',
	},
	syncTeamAdminDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.sync-team-admin-description-non-final',
		defaultMessage: 'Where to find it: Teams > Go to operations > Sync',
		description: 'Transition home, find what you are looking for step, sync description',
	},
	openTeamsNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.open-teams-non-final',
		defaultMessage: 'Open teams',
		description: 'Tooltip text of open teams button',
	},
	openAlertsNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.open-alerts-non-final',
		defaultMessage: 'Open alerts',
		description: 'Tooltip text of open alerts button',
	},
	openSchedulesNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.open-schedules-non-final',
		defaultMessage: 'Open on-call schedules',
		description: 'Tooltip text of open on-call schedules button',
	},
	openNotificationsNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.open-notifications-non-final',
		defaultMessage: 'Open personal notification settings',
		description: 'Tooltip text of open notification settings button',
	},
	viewReportsNonFinal: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX - ENABLING FLAT LINT CONFIG
		id: 'eoc-changeboarding.transition-home.find-step.view-reports-non-final',
		defaultMessage: 'View documentation',
		description: 'Tooltip text of open documentation of reports button',
	},
	openAuditLogsNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.open-audit-logs-non-final',
		defaultMessage: 'Open audit logs',
		description: 'Tooltip text of open audit logs button',
	},
	openRbnNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.open-rbn-non-final',
		defaultMessage: 'Open role-based notifications',
		description: 'Tooltip text of open role based notifications button',
	},
	openCustomRolesNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.open-custom-roles-non-final',
		defaultMessage: 'Open custom roles',
		description: 'Tooltip text of open custom roles button',
	},
	openAutomationNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.open-automation-non-final',
		defaultMessage: 'Open automation',
		description: 'Tooltip text of open automation button',
	},
	openSyncNonFinal: {
		id: 'eoc-changeboarding.transition-home.find-step.open-sync-non-final',
		defaultMessage: 'Open sync',
		description: 'Tooltip text of open sync button',
	},
});
